import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from "../services/configuration.service";
import { NotificationsService } from "angular2-notifications";
import { UserService } from "../services/user.service";
import { AssetsService } from "../services/assets.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { Globals } from "../app-globals";
import { AdminService } from "../services/admin.service";
@Component({
  selector: 'app-referralconfig',
  templateUrl: './referralconfig.component.html',
  styleUrls: ['./referralconfig.component.css']
})
export class ReferralconfigComponent implements OnInit {


  referal = {
    bonusamount: null,
    bonussenttype: '',
    bonussentcur: [],
    _csrf: '',
    updateId: '',
    bonusstatus: Number,
  }
  refcur = [];
  permission: String;

  dropdownSettings = {};
  selectedItems = []

  constructor(private configService: ConfigurationService,
    private notifSer: NotificationsService,
    private userService: UserService,
    private assetService: AssetsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    private global: Globals,
    private adminService: AdminService) { }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select Currency',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class'
    };
    if (!this.userService.isLoggedIn()) {
      this.router.navigateByUrl('/index');
    } else {
      if (typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length > 0) {
        var spt = this.router.url.split("/");
        var menu_url = spt[1];
        var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
        var adminrules = JSON.parse(localStorage.getItem('adminrules'));
        var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);
        if (index != -1) {
          var menuid = adminmenus[index]._id;
          var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
          this.permission = (adindex != -1) ? adminrules[adindex].permission : "write";
        }
      }
    }
    this.csrf();
  }
  csrf() {
    this.userService.csrf().subscribe((success) => {
      this.referal._csrf = success._csrf;
      this.getSettings();
      this.getCurrency();
    }, (error) => {
      console.log("ERROR___>")
    })
  }
  getCurrency() {
    this.configService.getAllCurrencies('fiat').subscribe(list => {
      var getdata = [];
      var datas = Object.keys(list).map(key => ({ id: key, itemName: list[key].code }));
      this.refcur = datas;
    });
  }

  getSettings() {
    this.configService.getRefsettings().subscribe(Referral => {
      this.referal.bonusamount = Referral.result[0].bonusamount;
      this.referal.bonussenttype = Referral.result[0].benfittype;
      this.referal.bonussentcur = Object.keys(Referral.result[0].bonussentcur).map(key => ({ id: key, itemName: Referral.result[0].bonussentcur[key].itemName }));
      this.referal.bonusstatus = Referral.result[0].bonusstatus;
      this.referal.updateId = Referral.result[0]._id;
      this.selectedItems = this.referal.bonussentcur;
    });
  }

  submit() {
    this.configService.updateRefsettings(this.referal).subscribe(success => {
      this.notifSer.success(
        'Status',
        'Referral Settings Updated',
        {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50
        }
      )
      this.spinnerService.hide();
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error(
        'Status',
        error.error.message,
        {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50
        }
      )
    });
  }


  onItemSelect(item: any) {
  }
  OnItemDeSelect(item: any) {
  }
  onSelectAll(items: any) {
  }
  onDeSelectAll(items: any) {
  }


}



// WEBPACK FOOTER //
// ./src/app/referralconfig/referralconfig.component.ts